import { Component } from 'react'
import { OnsetAge, OnsetDateTime, OnsetPeriod, OnsetRange, OnsetString, Code, CodeableConcept, Annotations, CodeableConcepts } from '../helpers'
import { GiMedicalThermometer } from 'react-icons/gi'

import './resource.css'

class Condition extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Condition${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.clinicalStatus && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.clinicalStatus && CodeableConcept(this.props.resource.clinicalStatus)}</div>
                        </div>
                        <div className='Res-Icon-Big'><GiMedicalThermometer /></div>
                        <div>
                            <div style={{textAlign: 'right'}} className='Res-Detail Res-Content-Rev'>{this.props.resource.verificationStatus && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.verificationStatus && CodeableConcept(this.props.resource.verificationStatus)}</div>
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.severity && 'Severity'}</div>
                            <div className='Res-Title'>{this.props.resource.severity && CodeableConcept(this.props.resource.severity)}</div>
                        </div>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.category && 'Category'}</div>
                            <div className='Res-Title'>{this.props.resource.category && CodeableConcepts(this.props.resource.category)}</div>
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.criticality && 'Criticality'}</div>
                            <div className='Res-Title'>{this.props.resource.criticality && Code(this.props.resource.criticality)}</div>
                        </div>
                        <div>
                            <div style={{textAlign: 'right'}} className='Res-Detail Res-Content-Rev'>{this.props.resource.code && 'Condition'}</div>
                            <div style={{textAlign: 'right'}} className='Res-Title'>{this.props.resource.code && CodeableConcept(this.props.resource.code)}</div>
                        </div>
                    </div>
                    {this.props.resource.onsetAge && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Onset</div>
                        <div className='Res-Detail'>{OnsetAge(this.props.resource.onsetAge)}</div>
                    </div>}
                    {this.props.resource.onsetDateTime && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Onset</div>
                        <div className='Res-Detail'>{OnsetDateTime(this.props.resource.onsetDateTime)}</div>
                    </div>}
                    {this.props.resource.onsetPeriod && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Onset</div>
                        <div className='Res-Detail'>{OnsetPeriod(this.props.resource.onsetPeriod)}</div>
                    </div>}
                    {this.props.resource.onsetRange && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Onset</div>
                        <div className='Res-Detail'>{OnsetRange(this.props.resource.onsetRange)}</div>
                    </div>}
                    {this.props.resource.onsetString && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Onset</div>
                        <div className='Res-Detail'>{OnsetString(this.props.resource.onsetString)}</div>
                    </div>}
                    {this.props.resource.abatementAge && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Abatement</div>
                        <div className='Res-Detail'>{OnsetAge(this.props.resource.abatementAge)}</div>
                    </div>}
                    {this.props.resource.abatementDateTime && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Abatement</div>
                        <div className='Res-Detail'>{OnsetDateTime(this.props.resource.abatementDateTime)}</div>
                    </div>}
                    {this.props.resource.abatementPeriod && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Abatement</div>
                        <div className='Res-Detail'>{OnsetPeriod(this.props.resource.abatementPeriod)}</div>
                    </div>}
                    {this.props.resource.abatementRange && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Abatement</div>
                        <div className='Res-Detail'>{OnsetRange(this.props.resource.abatementRange)}</div>
                    </div>}
                    {this.props.resource.abatementString && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Abatement</div>
                        <div className='Res-Detail'>{OnsetString(this.props.resource.abatementString)}</div>
                    </div>}
                    {this.props.resource.note && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Notes</div>
                        <div className='Res-Detail'>{Annotations(this.props.resource.note)}</div>
                    </div>}
                    {this.props.resource.recordedDate && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Recoreded Date</div>
                        <div className='Res-Detail'>{OnsetDateTime(this.props.resource.recordedDate)}</div>
                    </div>}
                </div>
            }
        </div></div>
    }
}

export default Condition